var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"person-info"},[_c('h3',[_vm._v(_vm._s(_vm.title))]),_c('p',[_c('span',{staticClass:"person-num"},[_vm._v(_vm._s(_vm.num))]),_vm._v(_vm._s(_vm.lang.person)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }